const VISIBLE_AFTER_PX = 800;

class ScrollToTop {
    private _button: HTMLButtonElement | null = null;

    init() {
        this._button = document.querySelector<HTMLButtonElement>("#scroll-to-top");

        if (!this._button) {
            return;
        }

        this._button.hidden = false;
        window.addEventListener("scroll", () => this.handleScroll(), { passive: true });
        this._button.addEventListener("click", () => this.scrollToTop());
    }

    handleScroll() {
        if (!this._button) {
            return;
        }

        this._button.classList.toggle("visible", window.scrollY > VISIBLE_AFTER_PX);
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
}

export default new ScrollToTop();
